import React, { useEffect } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router';
import { Grid } from '@material-ui/core';
import { push } from 'connected-react-router';
import { useDispatch, useSelector } from 'react-redux';

import { ViewFrame, Spinner } from '../../components';
import { useTitle } from '../../hooks';
import Account from './tab-account/Account';
import Team from './tab-team/Team';
import { selectOrganization, selectOrganizationForm } from '../../store/modules/organizations/selectors';
import { getOrganizationRequest } from '../../store/modules/organizations/actions';
import BillingTab from './tab-billing/BillingTab';
import TabRedirect from '../../components/tab-redirect/TabRedirect';
import SideTabs from '../../components/side-tabs/SideTabs';
import useStyles from '../../components/item-form/styles';


const OrganizationForm = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const { data, loading, error } = useSelector(selectOrganization);
  const { loading: loadingForm } = useSelector(selectOrganizationForm);
  const { params } = useRouteMatch<{id: string}>();
  const title = data?.common_name || 'New Organization';
  const loadingOrganization = loading || loadingForm;

  useTitle(title);

  useEffect(() => {
    const organizationId = parseInt(params.id, 10);

    if (data !== null) {
      if (organizationId && organizationId !== data.id) {
        dispatch(getOrganizationRequest(organizationId));
      }
    } else if (!loading && !error) {
      if (organizationId) {
        dispatch(getOrganizationRequest(organizationId));
      }
    }
  }, [dispatch, data, params, loading, error]);

  useEffect(() => {
    const hotKeyList = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key?.toLocaleLowerCase() === 'l') {
        event.preventDefault();
        dispatch(push('/dashboard/admin/organizations'));
      }
    };
    window.addEventListener('keydown', hotKeyList);

    return () => {
      window.removeEventListener('keydown', hotKeyList);
    };
  }, [dispatch]);

  if (loading) {
    return (
      <Grid container className={classes.spinnerWrapper}>
        <Spinner />
      </Grid>
    );
  }

  return (
    <ViewFrame
      loading={loadingOrganization}
      title={title}
      backToListLink
    >
      <TabRedirect />
      <Grid container spacing={1}>
        {!loadingOrganization && (
          <Grid item lg={2} xs={12}>
            <SideTabs variant="organizations" />
          </Grid>
        )}
        <Grid item xs={12} lg={10}>
          <Switch>
            <Route>
              <Account />
              <Team />
              <BillingTab />
            </Route>
          </Switch>
        </Grid>
      </Grid>
    </ViewFrame>
  );
};

export default OrganizationForm;
